<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>적하보험</li>
        <li>계약</li>
        <li>계약 통계</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>계약 통계</h2>
        <div class="depLink">
          <button type="button" title="메뉴"><span>계약 통계</span></button>
          <ul>
            <li>
              <router-link to="/contactpoint"
                ><span>알아두실 사항</span></router-link
              >
            </li>
            <li>
              <router-link to="/sbcpInpInqNdPolOtpt"
                ><span>청약 입력/조회 및 증권출력</span></router-link
              >
            </li>
            <li>
              <router-link to="/subsChangeForm"
                ><span>증권 간략 정정</span></router-link
              >
            </li>
            <li>
              <router-link to="/unpaidList"><span>미납조회</span></router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="contents">
      <div class="conWrap">
        <div class="tabBtn">
          <router-link to="/staMon"><span>월별 계약현황</span></router-link>
          <router-link to="/staItem"><span>품목별 계약현황</span></router-link>
          <a href="#" class="active"><span>지역별 계약현황</span></a>
        </div>

        <div class="sortWrap type2">
          <dl class="mgr20">
            <dt class="w72">발생월</dt>
            <dd>
              <div class="inpDate w488">
                <input
                  type="text"
                  v-model="I_FR_YM"
                  title="검색 시작일"
                  maxlength="6"
                  size="6"
                  @change="onChangeInpdt"
                  @keydown.enter="keydownHandler"
                  @keyup="StartKeyUpHandler"
                />
                <span>~</span>
                <input
                  type="text"
                  v-model="I_TO_YM"
                  title="검색 종료일"
                  maxlength="6"
                  size="6"
                  @change="onChangeInpdt"
                  @keydown.enter="keydownHandler"
                  @keyup="EndKeyUpHandler"
                />
              </div>
            </dd>
          </dl>
          <dl>
            <dt>보험품종</dt>
            <dd>
              <div class="inpSlt">
                <button type="button" class="sltBtn" title="조건 선택">
                  <span>전체</span>
                </button>
                <ul>
                  <li v-for="(item, index) in state.getIprodType" :key="index">
                    <button
                      type="button"
                      class="sltOpt"
                      title="선택"
                      @click="onSelectEvent('I_PROD_TYP', item)"
                    >
                      <span>{{ item.name }}</span>
                    </button>
                  </li>
                </ul>
              </div>
            </dd>
          </dl>
          <button type="button" class="btnSearch" @click="btnSearch(true)">
            <span class="hide">검색</span>
          </button>
        </div>
        <p class="inpInfo">조회기간은 현재 월로부터 과거 5년만 가능합니다.</p>

        <h3 class="conTit">조회결과</h3>
        <!-- <div class="graphWrap">그래프 영역</div> -->
        <table width="604">
          <tr>
            <td align="right">단위 : KRW 1원</td>
          </tr>
          <tr>
            <td class="pl10 pt10 pb3">
              <table
                width="594"
                border="0"
                cellpadding="2"
                cellspacing="1"
                bgcolor="ebebeb"
              >
                <tr>
                  <td>
                    <v-chart class="chart" :option="chartOption" autoresize />
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ is an alias to /src

import {
  ref,
  reactive,
  computed,
  inject,
  onMounted,
  onBeforeMount,
  onBeforeUpdate,
} from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import _ from "lodash";
import * as codeList from "@/common/code";

const axios = inject("axios");
let now = new Date();
const pastNowTime = util.formatDate(
  new Date(now.setMonth(now.getMonth() - 6)),
  "yyyymm"
);
const nowTime = util.formatDate(new Date(), "yyyymm");

const swalAlert = inject("swalAlert");
const swalConfirm = inject("swalConfirm");

let I_FR_YM = ref(null);
let I_TO_YM = ref(null);
let corp_no = ref(null);
let searchResult = ref([]);
const chartData = ref([]);

const state = reactive({
  getIprodType: [], //보험 종목
  ResultTotal: {}, //조회 결과
  jsonList: [],
  jsonObject: {},
  I_PROD_TYP: "",
  prem: "",
  arNm: "",
  rto: "",
  value: "",
  value1: "",
});

const onSelectEvent = (selectId, data) => {
  if (selectId == "I_PROD_TYP") {
    state.I_PROD_TYP = data.code;
  }
};
//페이지 진입시
onMounted(async () => {
  await load();
  console.log("로그인 정보값", sessionUserInfo);
  corp_no.value = sessionUserInfo.userInfo.corp_no;
  I_FR_YM.value = pastNowTime; //시작일
  I_TO_YM.value = nowTime; //종료일
  btnSearch(true);
});

//기간 조회
const onChangeInpdt = () => {
  console.log(
    "날짜",
    util.getDay(
      I_FR_YM.value.replace(/-/g, ""),
      I_TO_YM.value.replace(/-/g, "")
    )
  );
};

//조회
const btnSearch = async (reset) => {
  if (reset) {
    state.jsonList = [];
  }
  let param = {
    inqStMm: I_FR_YM.value.replace(/-/g, ""),
    inqEdMm: I_TO_YM.value.replace(/-/g, ""),
    salPdCd: state.I_PROD_TYP,
    polhdId: sessionUserInfo.slzCusInf.cusNo, //"10001326596"
  };
  let Result = await axios.transaction("FNGCTNFO0196", param);
  console.log(Result);
  searchResult.value = _.flatten([Result.body?.cargInetSticInqRslInfBcVo]);

  //파이 차트 데이터
  searchResult.value.forEach((data) => {
    let value = data.rto;
    let name = data.arNm;
    let value1 = data.prem;
    state.JsonObject = { value: value, name: name, value1: value1 };

    state.jsonList.push(state.JsonObject);
    chartData.value = state.jsonList;
  });
};
//파이 차트
const chartOption = computed(() => ({
  title: {
    left: "center",
  },

  tooltip: {
    trigger: "item",
    formatter: "{b} ({c}%)",
  },

  legend: {
    bottom: "bottom",
    formatter: (name) => {
      var series = _.filter(chartData.value, (d) => {
        return d.name == name;
      });
      series.forEach((data) => {
        state.value = data.value;
        state.value1 = util.addCommas(data.value1 + "");
      });
      return name + " " + state.value1 + " (" + state.value + "%)";
    },
  },
  series: [
    {
      type: "pie",
      radius: "50%",
      data: chartData.value,
    },
  ],
}));

//검색 엔터
const keydownHandler = (e) => {
  if (e.keyCode == "13") {
    btnSearch(true);
  }
};

//시작일 키업
const StartKeyUpHandler = (e) => {
  let keyCode = e.which;
  let ignoreKeyCodes =
    ",9,16,17,18,19,20,27,33,34,35,36,37,38,39,40,45,46,144,145,";
  if (!util.isNumeric(I_FR_YM.value)) {
    I_FR_YM.value = "";
    swalAlert("숫자만 입력 가능합니다. YYYYMM 형식으로 입력하세요");
  }
  if (ignoreKeyCodes.indexOf("," + keyCode + ",") > -1) {
    return;
  }
  if (keyCode == 8 && event.type == "keydown") {
    return;
  }
  console.log("키업", I_FR_YM.value.length);
  if (I_FR_YM.value.length == 6) {
    let frYy = I_FR_YM.value.substring(0, 4);
    let enYy = I_TO_YM.value.substring(0, 4);
    let frMm = I_FR_YM.value.substring(4);

    if(enYy - frYy > 5){
      swalAlert("조회기간은 최장 5년 입니다.");
      return;
    }
    if (frYy < 1900 || frYy > 2100) {
      I_FR_YM.value = "";
      swalAlert("조회시기가 적절하지 않습니다.");
      return;
    } else if (frMm > 12) {
      I_FR_YM.value = "";
      swalAlert("조회시기가 적절하지 않습니다.");
      return;
    } else if (parseInt(I_FR_YM.value) > parseInt(I_TO_YM.value)) {
      I_FR_YM.value = "";
      swalAlert("[조회 종료월]보다 더 작은 값을 입력하세요");
    } else {
      EndKeyUpHandler();
    }
  }
};

// 종료일 키업
const EndKeyUpHandler = (e) => {
  let keyCode = e.which;
  let ignoreKeyCodes =
    ",9,16,17,18,19,20,27,33,34,35,36,37,38,39,40,45,46,144,145,";
  if (!util.isNumeric(I_TO_YM.value)) {
    I_TO_YM.value = "";
    swalAlert("숫자만 입력 가능합니다. YYYYMM 형식으로 입력하세요");
  }
  if (ignoreKeyCodes.indexOf("," + keyCode + ",") > -1) {
    return;
  }
  if (keyCode == 8 && event.type == "keydown") {
    return;
  }
  if (I_TO_YM.value.length == 6) {
    let frYy = I_TO_YM.value.substring(0, 4);
    let frMm = I_TO_YM.value.substring(4);

    if (frYy < 1900 || frYy > 2100) {
      I_TO_YM.value = "";
      swalAlert("조회시기가 적절하지 않습니다.");
      return;
    } else if (frMm > 12) {
      I_TO_YM.value = "";
      swalAlert("조회시기가 적절하지 않습니다.");
      return;
    }
  }
};

init();

async function init() {
  state.getIprodType = codeList.getIprodType;
  axios.json('/logHisLdg.do', {memo:"지역별 계약 현황",page:window.location.hash});
}
</script>

<style>
.chart {
  height: 800px;
}
</style>
